module.exports = __webpack_public_path__ + "img/nailuxury.cae61ea9.jpg";